<div class="portfolio-list">
  <div class="oes-grid d-flex justify-content-end">
    <ng-container *ngIf="listType; else ProjectListHint">
      <h2>{{ 'portfolio-list.' + listType | translate }}</h2>
    </ng-container>

    <ng-template #ProjectListHint>
      <oes-notify class="hint" [type]="'warning'" [iconName]="'fa-clock-o'">
        <span class="hint-content">
          <span class="font-weight-bold">{{ 'project-list.hint.e' | translate }}</span>
          {{ 'project-list.hint.f' | translate }}
          <span class="font-weight-bold">{{ localTimeZone }}</span>
        </span>
      </oes-notify>
    </ng-template>

    <div class="sub-action-container">
      <oes-grid-sub-action
        *ngIf="gridApi"
        [gridState]="gridState"
        [defaultGridState]="defaultGridState"
        (action)="subAction($event)">
      </oes-grid-sub-action>
    </div>
  </div>
  <div class="ag-grid-header-sticky" oesAgHorizontalScroll oesAgColumns>
    <ag-grid-angular #agGrid
      style="width: auto"
      class="grid ag-theme-alpine"
      [gridOptions]="gridOptions"
      (gridReady)="onGridReady($event)"
      (cellValueChanged)="cellValueChanged($event)"
      (cellClicked)="cellClicked($event)"
      (filterChanged)="gridStatusChanged($event, 'filter')"
      (sortChanged)="gridStatusChanged($event, 'sort')"
      (displayedColumnsChanged)="gridStatusChanged($event, 'column')">
    </ag-grid-angular>
  </div>
</div>

<oes-modal-dialog
  #projectStatusesModal
  class="project-statuses-modal"
  [class.leave-unchanged]="!updateProjectStatuses"
  [size]="'medium'"
  [allowCancel]="true"
  [allowSubmit]="false"
  [cancelButtonText]="cancelButtonText"
  [submitButtonText]="'buttons.confirm' | translate"
  [title]="'project-list.port-statuses-updated' | translate">
  <div class="status-updates">
    <p>{{ 'project-list.update-assoc-projects' | translate }}</p>
    <div>
      <label>
        <input type="radio"
               class="style-overhaul-flag"
               name="updateProjectStatuses"
               (change)="setCancelButtonText()"
               [(ngModel)]="updateProjectStatuses"
               [value]="false"/>
        <span class="label-text">{{ 'project-list.leave-unchanged' | translate }}</span>
      </label>
      <label [class.disabled]="!selectedDealProgramId">
        <input type="radio"
               class="style-overhaul-flag"
               name="updateProjectStatuses"
               [disabled]="!selectedDealProgramId"
               (change)="setCancelButtonText()"
               [(ngModel)]="updateProjectStatuses"
               [value]="true"/>
        <span class="label-text">{{ 'project-list.update-project-statuses' | translate }}<span *ngIf="!selectedDealProgramId"> {{ 'project-list.update-project-statuses-no-program-suffix' | translate }}</span></span>
      </label>
    </div>
  </div>
  <ng-container *ngIf="projectGroupProjects?.length && updateProjectStatuses">
    <div class="bulk-stage-update">
      <oes-stage-update-bulk
        (reload)="projectStatusesModal.hide()"
        [showDescription]="false"
        [showMessageInput]="false"
        [programId]="selectedDealProgramId"
        [selectedProjects]="projectGroupProjects">
      </oes-stage-update-bulk>
    </div>
  </ng-container>
</oes-modal-dialog>
